import React from 'react';
import Columnas from "./components/Columnas";
import { candidatesData, psychometricTestsData, interviewData } from './components/utils/data';

const Seleccion: React.FC = () => {
  return (
    <div className="p-4">
      <div className="flex items-center justify-between mb-4">
        <nav className="flex space-x-4">
          <button className="text-blue-600 font-semibold">Proceso</button>
          <button>Formularios</button>
          <button>Estadísticas</button>
          <button>Automatización</button>
        </nav>
        <button className="bg-blue-600 text-white px-4 py-2 rounded">Acciones</button>
      </div>
      <h2 className="text-xl font-bold mb-4">Etapas del proceso</h2>
      <div className="flex space-x-4">
        <Columnas title="Postulantes" count={candidatesData.length} candidates={candidatesData} />
        <Columnas title="Pruebas Psicométricas" count={psychometricTestsData.length} candidates={psychometricTestsData} />
        <Columnas title="Entrevistas" count={interviewData.length} candidates={interviewData} />
      </div>
    </div>
  );
};

export default Seleccion;
